import Styles from './Uploads.module.scss'
import { SelectionCount } from 'components/ImagePickerModal/SelectionCount'
import { ConfirmSelectionButton } from 'components/ImagePickerModal/ConfirmSelectionButton'
import { ScrollContainer } from 'components/ImagePickerModal/ScrollContainer/ScrollContainer'
import { useUploads } from 'components/Design/UploadsTab/useUploads'
import { collectResults } from 'utils/query'
import { getMediaFiles } from 'components/Design/UploadsTab/getMediaFiles'
import { useImagePickerContext } from 'components/ImagePickerModal/ImagePickerContext'
import InfiniteScroll from 'common/InfiniteScroll/InfiniteScroll'
import { Portal } from 'components/Portal/Portal'
import { UploadsProps } from './Types'
import { ImageThumbnail } from 'components/ImagePickerModal/ImageThumbnail/ImageThumbnail'

const Uploads = ({ actionsContainerRef, confirmLabel = 'Add To Post' }: UploadsProps) => {
  const uploadsQuery = useUploads()
  const uploads = collectResults(uploadsQuery, (data) => data.files)
  const mediaFiles = getMediaFiles(uploads)
  const { hasNextPage, fetchNextPage } = uploadsQuery
  const context = useImagePickerContext()
  const { selectedImages, toggleSelectedImage, onConfirm } = context

  const handleConfirm = async () => {
    if (context.onBeforeConfirm) {
      const confirmed = await context.onBeforeConfirm(selectedImages)
      if (!confirmed) {
        return
      }
    }
    onConfirm(selectedImages, context)
  }

  return (
    <div data-testid="uploads-provider">
      <>
        <Portal container={actionsContainerRef}>
          <SelectionCount />
          <ConfirmSelectionButton
            onPress={handleConfirm}
            isDisabled={selectedImages.length === 0}
            confirmLabel={confirmLabel}
          />
        </Portal>
      </>
      <div className={Styles.allUploads}>
        <ScrollContainer>
          <div className={Styles.allUploadsGrid}>
            {mediaFiles.map((mediaFile) => (
              <div key={mediaFile.id} className={Styles.allUploadsItem}>
                <ImageThumbnail
                  image={{ ...mediaFile, url: mediaFile.thumbnail_url as string }}
                  onToggleSelect={toggleSelectedImage}
                  isSelected={selectedImages.some((i) => i.url === mediaFile.thumbnail_url)}
                  duration={mediaFile.duration}
                />
              </div>
            ))}
          </div>
          {hasNextPage && (
            <div className={Styles.infiniteLoader}>
              <InfiniteScroll hasMore={hasNextPage} loadMore={fetchNextPage} />
            </div>
          )}
        </ScrollContainer>
      </div>
    </div>
  )
}

export { Uploads }
